import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import HeaderConnected from "../Header_connected/HeaderConnected";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "../../actions";

export default function HeaderAdmin({ isAuth }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [routeSelected, setRouteSelected] = useState();
  const dispatch = useDispatch();
  const [showLogOutButton, setShowLogOutButton] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isRouteActive = (route) => {
    return route === "/admin/certifications"
      ? location.pathname === route || location.pathname === "/"
      : location.pathname === route;
  };
  const [initials, setInitials] = useState();

  const generateInitials = useCallback(() => {
    if (user?.data.firstName && user?.data.lastName) {
      setInitials(
        `${user?.data.firstName.charAt(0)}${user?.data.lastName.charAt(0)}`
      );
    } else setInitials(`${user?.data.email.charAt(0)}`);
  }, [user]);

  const onChangeRoute = (route) => {
    navigate(route);
  };

  const handleShowLogoutButton = () => {
    setShowLogOutButton(true);
    setTimeout(() => {
      setShowLogOutButton(false);
    }, 2000);
  };

  const handleLogOut = () => {
    dispatch(userActions.logout());
    navigate("/");
  };

  useEffect(() => {
    if (!isAuth) {
      navigate("/");
    } else {
      generateInitials();
    }
  }, [isAuth, navigate, generateInitials]);

  return (
    <header className="z-40">
      <span className="logo">
        <Link to={isAuth ? "/dashboard" : "/"}>
          <img src="/assets/images/logo-white.png" alt="" />
        </Link>
      </span>
      <ul className="menu">
        <li>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "none")}
            to="/admin/users"
          >
            Users
          </NavLink>
        </li>
        <li>
          <NavLink
            className={({ isActive }) =>
              isRouteActive("/admin/certifications") ? "active" : "none"
            }
            to={"/admin/certifications"}
          >
            Applications
          </NavLink>
        </li>
        <div className="connected flex items-center">
          <div className="user-connected">
            <span>{initials}</span>
          </div>
          <div className="dropdown relative ml-2">
            <img
              className="cursor-pointer"
              src="/assets/icons/dropdown.svg"
              alt=""
              onClick={handleShowLogoutButton}
            />
            {showLogOutButton && (
              <div className="absolute right-0 mt-2 top-11 ">
                <button
                  className="block flex items-center px-4 py-2 text-gray-800 hover:bg-gray-100 bg-white rounded-md shadow-lg"
                  onClick={handleLogOut}
                >
                  Logout
                  <img
                    className="ml-2 w-4 h-4"
                    src="/assets/icons/logout.svg"
                    alt=""
                  />
                </button>
              </div>
            )}
          </div>
        </div>
      </ul>
    </header>
  );
}
